import React from 'react';
import Lottie from 'react-lottie';
import * as ellipsisAnimation from './AnimationData/ellipsis.json';

interface AnimatedEllipsisProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const AnimatedEllipsis = ({ ...props }: AnimatedEllipsisProps) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ellipsisAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return <Lottie options={defaultOptions} {...props} />;
};
